export default __webpack_public_path__ + "static/media/inlife-logo-white.cbcf3db3.png";